<template>
  <div class="download-codes-container">
    <div class="content-card">
      <div class="content-title">我的下载码</div>

      <el-table
          :data="downloadCodes"
          border
          stripe
          v-loading="loading"
          v-if="downloadCodes.length > 0 || loading"
          element-loading-text="加载中..."
          style="width: 100%;"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#666',
            fontSize: '2.5rem',
            textAlign: 'center'
          }"
          :cell-style="{
            fontSize: '2rem',
            textAlign: 'center'
          }"
      >
        <el-table-column
            prop="downloadCode"
            label="下载码"
            width="300"
        >
        </el-table-column>

        <el-table-column
            prop="cloudDepotTitle"
            label="云仓标题"
            min-width="200"
        ></el-table-column>

        <el-table-column
            prop="remainingDownloads"
            label="剩余下载次数"
            width="180"
        >
          <template #default="scope">
            <span :class="scope.row.remainingDownloads > 0 ? 'remaining-enough' : 'remaining-exhausted'" style="font-size: 1.2rem">
              {{ scope.row.remainingDownloads }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
            label="操作"
            width="200"
        >
        <template #default="scope">
          <div class="operation-buttons">
            <el-button
                type="text"
                size="small"
            @click="copyCode(scope.row.downloadCode)"
            class="copy-btn"
            >
            复制下载码
            </el-button>
            <el-button
                type="text"
                size="small"
            @click="goToYunCang(scope.row.cloudDepotId)"
            class="goto-btn"
            >
            前往云仓
            </el-button>
          </div>
        </template>
        </el-table-column>
      </el-table>

      <!-- 空状态显示 -->
      <div class="empty-state" v-if="downloadCodes.length === 0 && !loading">
        <i class="el-icon-key"></i>
        <p>暂无下载码数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import newService from "@/api/newService";

export default {
  name: "MyDownloadCodes",
  data() {
    return {
      downloadCodes: [{code:'123',cloudTitle:'测试标题',remainingDownloads:10}],
      loading: false
    };
  },
  mounted() {
    this.fetchDownloadCodes();
  },
  methods: {
    // 获取下载码列表
    fetchDownloadCodes() {
      this.loading = true;
      const userId = this.$TOOL.data.get('USER_INFO').id;
      newService.getCodeByUserId(userId)
          .then(res => {
            this.downloadCodes = res || [];
          })
          .catch(err => {
            console.error('获取下载码失败:', err);
            this.$message.error('获取下载码失败，请稍后重试');
          })
          .finally(() => {
            this.loading = false;
          });
    },

    // 复制下载码到剪贴板
    copyCode(code) {
      navigator.clipboard.writeText(code)
          .then(() => {
            this.$message.success('下载码已复制到剪贴板');
          })
          .catch(() => {
            this.$message.error('复制失败，请手动复制');
          });
    },
    goToYunCang(cloudDepotId) {
      localStorage.setItem('cloudId',cloudDepotId)
      this.$store.state.components='yuncang1'
      this.$store.state.isbackground=true
      this.$store.state.iscolor=true
      this.$store.state.islogored=true
      document.body.scrollTop=document.documentElement.scrollTop=0
    },
  }
};
</script>

<style lang="scss" scoped>
.download-codes-container {
  .content-card {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 0.5rem;
    box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.05);
    padding: 3rem;
  }

  .content-title {
    font-size: 2.4rem;
    color: #333333;
    font-weight: 500;
    margin-bottom: 3rem;
    padding-bottom: 1rem;
    border-bottom: 0.1rem solid #E5E5E5;
  }

  ::v-deep .el-table {
    font-size: 1.6rem;
    border-radius: 0.5rem;
    overflow: hidden;

    .el-table__header th {
      background-color: #f9f9f9;
      color: #666;
      font-weight: 500;
    }
  }

  // 操作按钮容器
  .operation-buttons {
    display: flex;
    justify-content: center;
    padding: 0.5rem 0;
  }

  // 复制按钮样式（参考编辑/保存按钮红色风格）
  ::v-deep .copy-btn {
    font-size: 1.6rem;
    padding: 0.5rem 1.5rem;
    background-color: #FF0B41;
    color: #fff;
    border: 0.1rem solid #FF0B41;
    border-radius: 0.3rem;

    &:hover, &:focus {
      background-color: #e30a3a;
      color: #fff;
      border-color: #e30a3a;
      box-shadow: 0 0 0 0.2rem rgba(255, 11, 65, 0.2);
    }
  }

  // 前往云仓按钮样式（参考取消按钮风格）
  ::v-deep .goto-btn {
    font-size: 1.6rem;
    padding: 0.5rem 1.5rem;
    background-color: #fff;
    color: #333;
    border: 0.1rem solid #ddd;
    border-radius: 0.3rem;

    &:hover, &:focus {
      border-color: #FF0B41;
      color: #FF0B41;
      box-shadow: 0 0 0 0.2rem rgba(255, 11, 65, 0.1);
    }
  }

  // 图标样式调整
  ::v-deep .el-button i {
    margin-right: 0.5rem;
    font-size: 1.4rem;
  }

  .code-text {
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .remaining-enough {
    color: #52c41a;
    font-weight: 500;
  }

  .remaining-exhausted {
    color: #ff4d4f;
  }

  .empty-state {
    text-align: center;
    padding: 8rem 0;
    color: #999;

    .el-icon-key {
      font-size: 6rem;
      margin-bottom: 2rem;
      color: #ddd;
    }

    p {
      font-size: 1.8rem;
    }
  }
}
</style>
